import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './footer.scss';

const Footer = ({ children, className, shape, flexRow, lowered, spaceAround }) => (
  <footer className={classnames(className, styles.footer, styles[shape], {[styles.hasShape]: shape}, {[styles.lowered]:lowered})}>
    <div className={classnames(styles.bin, {[styles.spaceAround]: spaceAround, [styles.flexRow]: flexRow})}>
      {children}
    </div>
  </footer>
);

Footer.propTypes = {
  className: PropTypes.string,
  lowered: PropTypes.bool,
  shape: PropTypes.string,
  flexRow: PropTypes.bool,
  spaceAround: PropTypes.bool,
};

export { Footer };


// WEBPACK FOOTER //
// ./src/components/footer/footer.js